// extracted by mini-css-extract-plugin
module.exports = {"scrollArea":"sidebar_scrollArea__3xhQv"};